import type { AgendaItem } from "@elation/api-client/src/stitch-web/models/agendaItem";

import { AgendaItemEntity } from "./agenda-item.entity";

export interface AgendaAddressedProgress {
  addressed: number;
  total: number;
}

/**
 * Count actionable agenda items and how many are addressed (completed).
 */
export function countAddressedAgendaProgress(
  items: readonly AgendaItem[],
): AgendaAddressedProgress {
  const actionable = items.filter(AgendaItemEntity.isActionable);
  return {
    addressed: actionable.filter(AgendaItemEntity.isCompleted).length,
    total: actionable.length,
  };
}

/**
 * Format the Ed-style agenda progress label (style with CSS `uppercase`).
 */
export function formatAddressedAgendaProgressLabel(
  progress: AgendaAddressedProgress,
): string {
  return `Agenda • ${progress.addressed}/${progress.total} addressed`;
}
